// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fdbf1404","703":"6021fc0e","787":"df360243"}[chunkId] + ".chunk.js";
};